
export const openApiMixin = {
  methods: {
    focus() {
      this.$refs.autocomplete?.focus()
    },
    blur() {
      this.$refs.autocomplete?.blur()
    },
    reset() {
      this.$refs.autocomplete?.reset()
    },
  },
}
